import { useState } from 'react';

const ADMIN_MODE_STORAGE_KEY = 'adminMode';

const useAdminMode = () => {
  const [adminMode, setAdminModeState] = useState<boolean>(getAdminMode);

  const setAdminMode = (value: boolean) => {
    setAdminModeState(value);
    localStorage.setItem(ADMIN_MODE_STORAGE_KEY, String(value));
    window.location.reload();
  };

  return { adminMode, setAdminMode };
};

// For axios interceptor
export const getAdminMode = (): boolean => {
  try {
    return localStorage.getItem(ADMIN_MODE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};
